import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  GlobalNavigationService,
  NavigationInfo,
} from '@app/shared/services/global-navigation.service';
import { Subscription } from 'rxjs';

/**
 * Component responsible for rendering the top navigation menu.
 */
@Component({
  selector: 'dgx-top-navigation-menu',
  templateUrl: './top-navigation-menu.component.html',
  styleUrls: ['./top-navigation-menu.component.scss'],
})
export class TopNavigationMenuComponent implements OnInit, OnDestroy {
  public navigationInfo: NavigationInfo;
  private navigationInfoSubscription: Subscription;

  constructor(
    private router: Router,
    private globalNavigationService: GlobalNavigationService,
    private cdr: ChangeDetectorRef
  ) {}

  /**
   * Lifecycle hook called upon component initialization.
   */
  ngOnInit(): void {
    this.navigationInfoSubscription = this.setupNavigationSubscription();
  }

  /**
   * Lifecycle hook called just before Angular destroys the directive or component.
   */
  ngOnDestroy(): void {
    if (this.navigationInfoSubscription) {
      this.navigationInfoSubscription.unsubscribe();
    }
  }

  public isRouteActive(route: string): boolean {
    return this.router.isActive(route, true);
  }

  /**
   * Sets up the subscription to the NavigationService's observable.
   * @returns Subscription to the NavigationService's observable.
   */
  private setupNavigationSubscription(): Subscription {
    return this.globalNavigationService.navigationInfo$.subscribe(
      (navigationInfo) => {
        this.navigationInfo = navigationInfo;
        this.cdr.detectChanges();
      }
    );
  }
}
